var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 67,
    viewBox: "0 0 86 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M64.5974 44.9964L46.542 19.2029C45.8925 18.275 46.5563 17 47.6889 17L83.1444 17C84.277 17 84.9409 18.275 84.2913 19.2029L66.2359 44.9964C65.8378 45.5651 64.9955 45.5651 64.5974 44.9964Z",
    fill: "#FE004E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10_2",
    d: "M64.5974 44.9963L46.542 19.2028C45.8925 18.2749 46.5563 17 47.6889 17L83.1444 17C84.277 17 84.9409 18.2749 84.2913 19.2028L66.2359 44.9963C65.8378 45.565 64.9955 45.565 64.5974 44.9963Z",
    fill: "#FE004E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M35.2048 17.2926L55.1189 45.7412C55.49 46.2715 55.1107 47 54.4635 47L15.5365 47C14.8893 47 14.51 46.2715 14.8811 45.7412L34.7952 17.2926C34.8947 17.1504 35.1053 17.1504 35.2048 17.2926Z",
    fill: "#00F6EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M35.206 26.2997L45.1384 40.7468C45.5033 41.2776 45.1233 42 44.4792 42L25.5208 42C24.8767 42 24.4967 41.2776 24.8616 40.7468L34.794 26.2997C34.8933 26.1552 35.1067 26.1552 35.206 26.2997Z",
    fill: "#1E1E1E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6a586e17ce37905204a19fabd6184257.svg";
export { ForwardRef as ReactComponent };